import TaxiCorporationDetailsResponse, {
  TaxiCorporationDetailsResponseItem,
} from "../../../api/raily/taxi-corporation/details/taxi-corporation-details.response";
import TaxiCorporationDetails from "./taxi-corporation-details";

const createDataItem = (
  responseDataItem: TaxiCorporationDetailsResponseItem
): TaxiCorporationDetails => {
  return {
    name: responseDataItem.companyName,
    displayName: responseDataItem.displayName,
    uuid: responseDataItem.id,
  };
};

const create = (
  response: TaxiCorporationDetailsResponse
): TaxiCorporationDetails => {
  return createDataItem(response.data);
};

const taxiCorporationDetailsFactory = {
  create,
};

export default taxiCorporationDetailsFactory;
